import React from "react";
import BaseInput from "../../BaseComponents/BaseInput";
import BaseSelect from "../../BaseComponents/BaseSelect";
import { formFields, hrEnums } from "../../Constant/HR_Staff/hrEnums";
import { PlaceHolderFormat } from "../../Constant/requireMessage";
import { digitRegex } from "../../Constant/validation";
import { ProfileSection, InfoField } from "../../BaseComponents/ProfileSection";
import { CreditCard } from "react-feather";

const BankDetails = ({
  staffForm,
  viewBankMode,
  handleBankEdit,
  handleBankDiscard,
  editBankMode,
  staffData,
  btnLoader,
  bankList,
}) => {
  const isSaveDisabled = React.useMemo(() => {
    const fields = ["bank_name", "ifsc", "account_number", "account_holder_name"];

    return !fields.some((field) => {
      const val = staffForm.values[field];
      const initVal = staffForm.initialValues[field];

      const normalizedVal = val === null || val === undefined ? "" : String(val).trim();
      const normalizedInitVal =
        initVal === null || initVal === undefined ? "" : String(initVal).trim();
      return normalizedVal !== normalizedInitVal;
    });
  }, [staffForm.values, staffForm.initialValues]);

  return (
    <ProfileSection
      id="bank-info"
      title={hrEnums.BANK_INFO}
      icon={CreditCard}
      iconColor="#f59e0b"
      viewMode={viewBankMode}
      editMode={editBankMode}
      onEdit={handleBankEdit}
      onDiscard={handleBankDiscard}
      isEditable={true}
      btnLoader={btnLoader}
      animDelay="180ms"
      isSaveDisabled={isSaveDisabled}
    >
      {viewBankMode ? (
        <div className="row">
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.NAME_OF_BANK}
              value={staffData?.staffBankDetails?.name_of_bank}
            />
          </div>
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.IFSC_CODE}
              value={staffData?.staffBankDetails?.IFSC_code}
              mono
            />
          </div>
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.ACCOUNT_NO}
              value={staffData?.staffBankDetails?.account_no}
              mono
            />
          </div>
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.ACCOUNT_HOLDER_NAME}
              value={staffData?.staffBankDetails?.account_holder_name}
            />
          </div>
        </div>
      ) : (
        <div className="row g-3">
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseSelect
              label={hrEnums.NAME_OF_BANK}
              name={formFields.bank_name}
              placeholder={PlaceHolderFormat(hrEnums.NAME_OF_BANK)}
              value={staffForm.values.bank_name}
              touched={staffForm.touched.bank_name}
              error={staffForm.errors.bank_name}
              handleBlur={staffForm.handleBlur}
              handleChange={(name, val) => staffForm.setFieldValue(name, val)}
              options={bankList}
              isDisabled={btnLoader}
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseInput
              name={formFields.ifsc}
              type="text"
              label={hrEnums.IFSC_CODE}
              placeholder={PlaceHolderFormat(hrEnums.IFSC_CODE)}
              value={staffForm.values.ifsc}
              touched={staffForm.touched.ifsc}
              error={staffForm.errors.ifsc}
              handleBlur={staffForm.handleBlur}
              handleChange={staffForm.handleChange}
              disabled={btnLoader}
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseInput
              name={formFields.account_number}
              type="text"
              label={hrEnums.ACCOUNT_NO}
              placeholder={PlaceHolderFormat(hrEnums.ACCOUNT_NO)}
              value={staffForm.values.account_number}
              touched={staffForm.touched.account_number}
              error={staffForm.errors.account_number}
              handleBlur={staffForm.handleBlur}
              maxLength={17}
              handleChange={(e) => {
                if (digitRegex.test(e?.target?.value)) staffForm.handleChange(e);
              }}
              disabled={btnLoader}
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseInput
              name={formFields.account_holder_name}
              type="text"
              label={hrEnums.ACCOUNT_HOLDER_NAME}
              placeholder={PlaceHolderFormat(hrEnums.ACCOUNT_HOLDER_NAME)}
              value={staffForm.values.account_holder_name}
              touched={staffForm.touched.account_holder_name}
              error={staffForm.errors.account_holder_name}
              handleBlur={staffForm.handleBlur}
              handleChange={staffForm.handleChange}
              disabled={btnLoader}
            />
          </div>
        </div>
      )}
    </ProfileSection>
  );
};

export default BankDetails;
